import React, { useState, useEffect } from "react";
import {
  AppBar, Toolbar, Box, Typography, Button, Container
} from "@mui/material";
import { motion } from "framer-motion";
import { auth } from "../firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";

// const navItems = ["Home", "Tracker", "About", "Contact"];
const navItems = ["Home", "Tracker"];

export default function Navbar() {
  const [elevated, setElevated] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    signOut(auth)
      .then(() => navigate("/login"))
      .catch((err) => console.error("Sign-out error:", err));
  };

  const textColor = elevated ? "#fff" : "#000";

  return (
    <motion.div
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <AppBar
        position="fixed"
        elevation={elevated ? 4 : 0}
        sx={{
          bgcolor: elevated ? "rgba(0,0,0,0.85)" : "transparent",
          transition: "background-color 0.3s ease-in-out",
          backdropFilter: elevated ? "blur(8px)" : "none",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            <Typography
              variant="h6"
              sx={{
                flexGrow: 1,
                textAlign: "left",
                fontWeight: "bold",
                color: textColor,
              }}
            >
              HealthTrackAI
            </Typography>
            <Box sx={{ display: "flex", gap: 2 }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  sx={{ color: textColor }}
                  onClick={() => navigate(item.toLowerCase())}
                >
                  {item}
                </Button>
              ))}
              {user ? (
                <Button onClick={handleLogout} sx={{ color: textColor }}>
                  Sign Out
                </Button>
              ) : (
                <Button onClick={() => navigate("/login")} sx={{ color: textColor }}>
                  Sign In
                </Button>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </motion.div>
  );
}
